import { createTheme } from "@mui/material";

const defaultTheme = createTheme({
  direction: "rtl",
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: 'rgb(22, 95, 129)',
          fontFamily: 'Vazir-Medium'
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          fontSize: '1.2em !important',
          fontFamily: 'Vazir-Medium'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          '&.MuiInputLabel-shrink': {
            fontSize: '1.2em !important',
            fontFamily: 'Vazir-Medium',
            color: 'rgb(22, 95, 129)',
          }
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '& .MuiDataGrid-columnHeaderTitle': { fontSize: 14 },
          '& .MuiDataGrid-cell': { fontSize: 12 }
        }
      }
    }
  },
  typography: {
    fontSize: 14,
    fontFamily: [
      'Vazir-Medium',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#86A7FC',
      contrastText: '#fff'
    },
    secondary: {
      main: 'rgb(22, 95, 129)',
      contrastText: '#fff'
    },
    customOrange: {
      main: '#ff7043',
      contrastText: '#fff'
    },
    beige: {
      main: 'rgb(22, 95, 129)',
      contrastText: 'rgb(245, 245, 245)'
    },
    customRed: {
      main: '#ff0000',
      contrastText: '#fff'
    },
    IconColor: {
      main: '#5c6bc0',
      contrastText: '#fff'
    },
  }
});
const themes = { defaultTheme }
export default themes;